/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
function lazyLoadPlants() {
	const plant1 = document.querySelector('#hero-plant-1');
	const plant2 = document.querySelector('#hero-plant-2');
	const plant3 = document.querySelector('#hero-plant-3');
	const plant4 = document.querySelector('#hero-plant-4');
	const plant5 = document.querySelector('#hero-plant-5');

	plant1.src = plant1.dataset.src;
	plant2.src = plant2.dataset.src;
	plant3.src = plant3.dataset.src;
	plant4.src = plant4.dataset.src;
	plant5.src = plant5.dataset.src;
}

// requestIdleCallback doesnt work on safari
if ('requestIdleCallback' in window) {
	requestIdleCallback(() => {
		lazyLoadPlants()

	});
} else {
	lazyLoadPlants()
}




